import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { supabase } from './supabaseClient';

export default function AuthCallback() {
  const navigate = useNavigate();

  useEffect(() => {
    const handleCallback = async () => {
      try {
        console.log('AuthCallback: Checking session state...');
        const { data: { session }, error } = await supabase.auth.getSession();
        
        if (error) {
          console.error('AuthCallback: Error getting session:', error);
          navigate('/signin');
          return;
        }

        console.log('AuthCallback: Session state:', session);

        if (session?.user) {
          // If we have a user session, this is likely a password reset
          console.log('AuthCallback: Valid session found, redirecting to update password');
          navigate('/update-password');
        } else {
          console.log('AuthCallback: No session found, redirecting to sign in');
          navigate('/signin');
        }
      } catch (error) {
        console.error('AuthCallback: Unexpected error:', error);
        navigate('/signin');
      }
    };

    handleCallback();
  }, [navigate]);

  return (
    <div style={{ textAlign: 'center', marginTop: '40px', color: '#fff' }}>
      <h2>Processing Authentication...</h2>
      <p>Please wait while we verify your request.</p>
    </div>
  );
} 